import { c, s, t } from '../val.config';

const contactSalesSchema = s.object({
  title: s.string(),
  link: s.object({
    text: s.string(),
    href: s.string(),
  }),
});

export type ContactSales = t.inferSchema<typeof contactSalesSchema>;

export default c.define('/content/contactSales.val.ts', contactSalesSchema, {
  title: 'Har du et prosjekt du vil bringe til liv?',
  link: {
    text: 'La oss ta en prat',
    href: '/prosjektprat',
  },
});
